export const DYNAMIC_DATE_OPTIONS = [
  { value: "115", label: "Last 30 Days" },
  { value: "5", label: "Last 7 Days" },
  { value: "47", label: "Last Month" },
  { value: "48", label: "Last Month to Date" },
  { value: "49", label: "Last Quarter" },
  { value: "50", label: "Last Quarter to Date" },
  { value: "41", label: "Last Week" },
  { value: "46", label: "Last Week to Date" },
  { value: "51", label: "Last Year" },
  { value: "52", label: "Last Year to Date" },
  { value: "54", label: "Next 4 Weeks" },
  { value: "55", label: "Next Month" },
  { value: "56", label: "Next Quarter" },
  { value: "53", label: "Next Week" },
  { value: "57", label: "Next Year" },
  { value: "145", label: "Prior to Today" },
  { value: "40", label: "This Month" },
  { value: "33", label: "This Month to Date" },
  { value: "42", label: "This Quarter" },
  { value: "43", label: "This Quarter to Date" },
  { value: "38", label: "This Week" },
  { value: "39", label: "This Week to Date" },
  { value: "44", label: "This Year" },
  { value: "45", label: "This Year to Date" },
  { value: "34", label: "Today" },
  { value: "103", label: "Tomorrow" },
  { value: "35", label: "Yesterday" },
];

/** Dynamic date presets for report filter operator "dynamic" (evaluated at run time). */
export const REPORT_FILTER_DYNAMIC_DATE_OPTIONS = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "this_week", label: "This Week" },
  { value: "last_week", label: "Last Week" },
  { value: "this_month", label: "This Month" },
  { value: "last_month", label: "Last Month" },
  { value: "this_year", label: "This Year" },
  { value: "last_year", label: "Last Year" },
  {
    value: "current_month_1_to_15",
    label: "Current Month (1st – 15th)",
  },
  {
    value: "prior_month_16_to_end",
    label: "Prior Month (16th – End)",
  },
  {
    value: "current_month_16_to_end",
    label: "Current Month (16th – End)",
  },
];

const LEGACY_DYNAMIC_DATE_LABELS = {
  today: "Today",
  yesterday: "Yesterday",
  this_week: "This Week",
  last_week: "Last Week",
  this_month: "This Month",
  last_month: "Last Month",
  this_year: "This Year",
  last_year: "Last Year",
  current_month_1_to_15: "Current Month (1st – 15th)",
  prior_month_16_to_end: "Prior Month (16th – End)",
  current_month_16_to_end: "Current Month (16th – End)",
};

export const isReportFilterDynamicValue = (value) =>
  typeof value === "string" &&
  REPORT_FILTER_DYNAMIC_DATE_OPTIONS.some((option) => option.value === value);

export const normalizeFilterValueForOperator = (filter, nextOperator) => {
  const { type, value } = filter;

  if (type === "date") {
    if (nextOperator === "dynamic") {
      return isReportFilterDynamicValue(value) ? value : "";
    }
    if (nextOperator === "between") {
      if (value && typeof value === "object" && !Array.isArray(value)) {
        return { from: value.from || "", to: value.to || "" };
      }
      return { from: "", to: "" };
    }
    if (typeof value === "string") return value;
    return "";
  }

  return value;
};

export const getDynamicDateOption = (value) => {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "object") return null;
  const normalized = String(value);
  return (
    DYNAMIC_DATE_OPTIONS.find((option) => option.value === normalized) ||
    REPORT_FILTER_DYNAMIC_DATE_OPTIONS.find((option) => option.value === normalized) || {
      value: normalized,
      label: LEGACY_DYNAMIC_DATE_LABELS[normalized] || normalized,
    }
  );
};
